import ControllerReels from 'Engine/base/reels/ControllerReels';
import EntryPoint from 'Engine/EntryPoint';

export default class ControllerBonusReels extends ControllerReels {
  constructor(...args) {
    super(...args);

    this.init(EntryPoint.GameModel.bonusGameAvailableReels);

    this.reels.forEach((reel) => {
      let mask = new PIXI.Graphics();
      mask.beginFill(0x0, 1);
      mask.drawRect(-206, 140, 410, 272);
      mask.endFill();
      reel.addChild(mask);
      reel.mask = mask;
    });
  }
}
